<template>
  <div :class="'cargo-area'+(notClick?' not-click':'')">
    <el-form-item :label="$t('CargoMsg.Cargo_Province')" :required="isRequired" :label-width="provinceLabelWidth ? provinceLabelWidth+'px' : labelWidth+'px'">
      <cargo-advance-select
        :allow-create="allowCreate"
        :filterable="filterable"
        :select-type="selectTypeNames.basic_data_AdministrativeDivision"
        :callback-params="{key:'code'}"
        :default-value="innerProvince"
        :disabled="provinceDisabled"
        :static-options="provinceList"
        tag-name="name"
        tag-value="code"
        :placeholder="placeholder"
        :fields="['code']"
        :style="{width:typeof selectWidth === 'number'?selectWidth+'px':selectWidth}"
        @parentCallBack="provinceChangeHandler"
      />
    </el-form-item>
    <el-form-item :label="cityLabelName?cityLabelName:$t('CargoMsg.Cargo_city')" :required="isRequired" :label-width="cityLabelWidth ? cityLabelWidth+'px' : labelWidth+'px'">
      <cargo-advance-select
        ref="city"
        :allow-create="allowCreate"
        :filterable="filterable"
        :select-type="selectTypeNames.basic_data_AdministrativeDivision"
        :callback-params="{key:'code'}"
        :default-value="innerCity"
        :disabled="cityDisabled"
        :static-options="cityList"
        tag-name="name"
        tag-value="code"
        :placeholder="placeholder"
        :fields="['code']"
        :style="{width:typeof selectWidth === 'number'?selectWidth+'px':selectWidth}"
        @parentCallBack="cityChangeHandler"
      />
    </el-form-item>
    <el-form-item :label="districtLabelName?districtLabelName:$t('CargoMsg.Cargo_District')" :required="isRequired" :label-width="districtLabelWidth ? districtLabelWidth+'px' : labelWidth+'px'">
      <cargo-advance-select
        ref="district"
        :allow-create="allowCreate"
        :filterable="filterable"
        :select-type="selectTypeNames.basic_data_AdministrativeDivision"
        :callback-params="{key:'code'}"
        :default-value="innerDistrict"
        :disabled="districtDisabled"
        :static-options="districtList"
        tag-name="name"
        tag-value="code"
        :placeholder="placeholder"
        :fields="['code']"
        :style="{width:typeof selectWidth === 'number'?selectWidth+'px':selectWidth}"
        @parentCallBack="districtChangeHandler"
      />
    </el-form-item>
    <el-form-item v-if="showTown" :style="townStyle" :label="townLabelName?townLabelName:$t('CargoMsg.Cargo_StreetTownship')" :required="isRequired" :label-width="townLabelWidth ? townLabelWidth+'px' : labelWidth+'px'">
      <cargo-advance-select
        ref="town"
        :allow-create="allowCreate"
        :filterable="filterable"
        :callback-params="{key:'uuid'}"
        :default-value="innerTown"
        :disabled="townDisabled"
        :static-options="townList"
        tag-name="name"
        tag-value="uuid"
        :placeholder="placeholder"
        :fields="['uuid']"
        :filter-tag-names="['name']"
        :style="{width:typeof selectWidth === 'number'?selectWidth+'px':selectWidth}"
        @parentCallBack="townChangeHandler"
      />
    </el-form-item>
  </div>
</template>

<script>
import { sleep, SyncManager } from '@/utils/commonUtil'
import { getCountryByCode } from '@/api/country'
import { getDivisionList } from '@/api/division'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getTownByDistrictUuid } from '@/api/basicData/town'

export default {
  name: 'CargoArea',
  components: { CargoAdvanceSelect },
  props: {
    placeholder: { type: String, default: '' },
    townStyle: { type: Object, default: () => { return {} } },
    source: { type: String, default: null },
    allowCreate: { type: Boolean, required: false },
    country: { type: String, required: false },
    province: { type: String, required: true, default: '' },
    city: { type: String, required: true, default: '' },
    district: { type: String, required: true, default: '' },
    town: { type: String, required: false, default: '' },
    cityLabelName: { type: String, default: null },
    districtLabelName: { type: String, default: null },
    townLabelName: { type: String, default: null },
    labelWidth: { type: String, default: null },
    provinceDisabled: { type: Boolean, default: false },
    cityDisabled: { type: Boolean, default: false },
    districtDisabled: { type: Boolean, default: false },
    townDisabled: { type: Boolean, default: false },
    provinceLabelWidth: { type: String, default: null },
    cityLabelWidth: { type: String, default: null },
    districtLabelWidth: { type: String, default: null },
    townLabelWidth: { type: String, default: null },
    selectWidth: { type: [Number, String], default: 170 },
    isRequired: { type: Boolean, required: false },
    filterable: { type: Boolean, default: true },
    showTown: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      notClick: true,
      syncManager: new SyncManager(),
      cache: new Map(),
      provinceList: [],
      cityList: [],
      districtList: [],
      townList: [],
      innerProvince: this.province || '',
      innerCity: this.city || '',
      innerDistrict: this.district || '',
      innerTown: this.town || ''
    }
  },
  watch: {
    country(newVal) {
      this.init(newVal)
    },
    province(newVal) {
      this.innerProvince = newVal || ''
    },
    innerProvince(newVal) {
      this.$emit('update:province', newVal)
      if (newVal) {
        this.syncManager.execute(async() => {
          await this.getDivisionByParentCode(this.innerProvince, 2)
        })
      }
    },
    city(newVal) {
      this.innerCity = newVal || ''
    },
    innerCity(newVal) {
      this.$emit('update:city', newVal)
      if (newVal) {
        this.syncManager.execute(async() => {
          await this.getDivisionByParentCode(this.innerCity, 3)
        })
      }
    },
    district(newVal) {
      this.innerDistrict = newVal || ''
    },
    innerDistrict(newVal) {
      this.$emit('update:district', newVal)
      if (newVal && this.showTown) {
        this.syncManager.execute(async() => {
          await this.getDivisionByParentCode(this.innerDistrict, 4)
        })
      }
    },
    town(newVal) {
      this.innerTown = newVal || ''
    },
    innerTown(newVal) {
      this.$emit('update:town', newVal)
    }
  },
  created() {
    this.$nextTick(() => {
      this.init(this.country)
    })
  },
  methods: {
    async init(countryCode) {
      this.notClick = true
      try {
        // 根据二字码查询国家（默认为中国）
        let countryUuid = ''
        if (countryCode) {
          countryUuid = await getCountryByCode(countryCode).then(res => {
            return res.data ? res.data.uuid : ''
          })
        }
        // 初始化省份信息
        await this.getDivisionByParentId(countryUuid, 1)
        if (this.province) {
          this.innerProvince = this.province
          // 初始化市信息
          await this.getDivisionByParentCode(this.innerProvince, 2)
          if (this.city) {
            this.innerCity = this.city
            // 初始化区信息
            await this.getDivisionByParentCode(this.innerCity, 3)
            if (this.district) {
              this.innerDistrict = this.district
              // 初始化街道信息
              if (this.showTown) {
                await this.getDivisionByParentCode(this.district, 4)
                if (this.town) {
                  this.innerTown = this.town
                }
              }
            }
          }
        }
      } finally {
        this.notClick = false
      }
    },
    /**
     * 根据父级代码获取区域信息
     * @param parentCode 父级代码
     * @param type 2.城市;3.地区
     */
    async getDivisionByParentCode(parentCode, type) {
      switch (type) {
        case 2:
          const provinces = this.provinceList.filter(p => p.code === parentCode)
          if (provinces.length > 0) {
            await this.getDivisionByParentId(provinces[0].uuid, type)
          } else {
            this.cityList = []
          }
          break
        case 3:
          const cities = this.cityList.filter(p => p.code === parentCode)
          if (cities.length > 0) {
            await this.getDivisionByParentId(cities[0].uuid, type)
          } else {
            this.districtList = []
          }
          break
        case 4:
          const districts = this.districtList.filter(p => p.code === parentCode)
          if (districts.length > 0) {
            await this.getDivisionByParentId(districts[0].uuid, type)
            // this.townList = await this.getTownByDistrictUuid({ districtUuid: districts[0].uuid}).then(res => res.data)
          } else {
            this.townList = []
          }
          break
        default: break
      }
    },
    /**
     * 根据parentId获取区域信息
     * @param parentId 父级ID
     * @param type 1.省份;2.城市;3.地区
     */
    async getDivisionByParentId(parentId, type) {
      let data = null
      if (parentId) {
        data = this.cache.get('division/' + parentId)
        if (!data) {
          if (type === 4) {
            await getTownByDistrictUuid({ districtUuid: parentId }).then(res => {
              data = res.data
              this.cache.set('division/' + parentId, data)
            })
          } else {
            await getDivisionList(parentId).then(res => {
              data = res.data
              this.cache.set('division/' + parentId, data)
            })
          }
        }
      } else {
        data = []
      }
      switch (type) {
        case 1: this.provinceList = data; break
        case 2: this.cityList = data; break
        case 3: this.districtList = data; break
        case 4: this.townList = data; break
        default: break
      }
    },
    provinceChangeHandler(obj) {
      this.innerProvince = obj.value
      this.innerCity = ''
      this.innerDistrict = ''
      this.innerTown = ''
      this.clearCity()
      this.clearDistrict()
      this.clearTown()
    },
    cityChangeHandler(obj) {
      this.innerCity = obj.value
      this.innerDistrict = ''
      this.innerTown = ''
      this.clearDistrict()
      this.clearTown()
    },
    clearCity() {
      this.cityList = []
    },
    districtChangeHandler(obj) {
      this.innerDistrict = obj.value
      this.innerTown = ''
      this.clearTown()
    },
    clearDistrict() {
      this.districtList = []
    },
    townChangeHandler(obj) {
      this.innerTown = obj.value
    },
    clearTown() {
      this.townList = []
    }
  }
}
</script>

<style lang="scss">
.cargo-area {
  .el-form-item__content {
    width: auto;
  }
}
</style>

<style scoped>
.not-click {
  pointer-events: none;
}
</style>
